import React, {
  PropTypes,
} from 'react';
import './ContentCard.scss';
import BckImg from '../BckImg/BckImg'

function ContentCard(props) {
  return (
    <div>
      <BckImg
        className="row align-center"
        src={props.image}
        thumb={props.image}
        backgroundStyle={props.backgroundStyle}
      >
        {props.children}
      </BckImg>
      <div className="row align-center">
        <h5 className="content__title">{props.title}</h5>
      </div>
      <div className="row align-center">
        <h6 className="content__description">{props.description}</h6>
      </div>

    </div>
  );
}

ContentCard.propTypes = {};
ContentCard.defaultProps = {};

export default ContentCard;





// WEBPACK FOOTER //
// ./src/components/Common/Card/ContentCard.jsx